module.exports = __webpack_public_path__ + "static/media/65.80789953.jpg";